import { Page } from 'components';
import { useContext } from 'react';
import {  Results } from './components';
import { ticketTypesContext } from './TicketTypesContext';

let TicketType = () => {
    let { isLoading } = useContext(ticketTypesContext);

    return (
        <Page
            isLoading={isLoading}
            useHeader={true}
            title="Ticket Types"
            addNewUrl="/admin/ticketType/addnew"
        >
            <Results />
        </Page>
    )
}

export default TicketType;